import React from 'react';
import PropTypes from 'prop-types';

import { getVisitFormOptions } from '../../../DashboardRecord/utils/getVisitFormData';
import { useChangeStatusForm } from '../utils/useStatusInfoFormState';
import { ChangeStatusForm } from './ChangeStatusForm';
import Button from '../../../Button';
import { enhance } from './enhance';

const ChangeStatusModal = ({
  intl: { formatMessage },
  errors,
  options,
  pending,
  hidePopup,
  changeStatus,
}) => {
  const { isValid, formState, handleFormChange } = useChangeStatusForm();
  const { id, status } = options;
  const {
    id: statusId,
    statusChangeLocations,
    statusChangeReasonTypes,
  } = status;

  const handleSubmit = e => {
    e.preventDefault();
    changeStatus({ id, statusId, ...formState });
  };

  return (
    <form onSubmit={handleSubmit} className={pending ? 'disabled' : ''}>
      <ChangeStatusForm
        {...formState}
        formatMessage={formatMessage}
        onChange={handleFormChange}
        locationsList={getVisitFormOptions(statusChangeLocations)}
        reasonList={getVisitFormOptions(statusChangeReasonTypes)}
        errors={errors}
      />
      <div className="mt3">
        <Button
          className="mr3"
          type="submit"
          raised
          color="primary"
          disabled={!isValid || pending}
        >
          {formatMessage({ id: 'common.save' })}
        </Button>
        <Button
          className="mr3"
          type="button"
          onClick={hidePopup}
          raised
          color="accent"
        >
          {formatMessage({ id: 'common.cancel' })}
        </Button>
      </div>
    </form>
  );
};

ChangeStatusModal.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  changeStatus: PropTypes.func,
  pending: PropTypes.bool,
  options: PropTypes.object,
  hidePopup: PropTypes.func,
  errors: PropTypes.object,
};

export default enhance(ChangeStatusModal);



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardTable/ChangeStatus/index.jsx